import { Filter, type SelectItem } from '@vrplatform/components';
import { useEnabledFeatures } from '@vrplatform/data';
import { Icon } from '@vrplatform/icons';
import type { Maybe } from '@vrplatform/utils';
import type { BaseCustomFilterProps } from './_types';

export type BookFilterValue = 'trust' | 'operating';

interface Props extends BaseCustomFilterProps {
  book: Maybe<BookFilterValue>;
  setBook: (book: BookFilterValue | null) => void;
}

const OPTIONS: SelectItem<BookFilterValue>[] = [
  {
    value: 'trust',
    label: 'Trust',
    icon: <Icon icon="BookOpenIcon" size={14} />,
  },
  {
    value: 'operating',
    label: 'Operating',
    icon: <Icon icon="BriefcaseIcon" size={14} />,
  },
];

export const BookFilter = ({ book, setBook, label = 'Book' }: Props) => {
  const { OPEX } = useEnabledFeatures();
  const value = OPTIONS.find((option) => option.value === book) ?? null;

  if (!OPEX) return null;

  return (
    <Filter.Select
      type="single"
      label={label}
      value={value}
      data={{
        options: OPTIONS,
      }}
      setValue={(updated) => {
        setBook(updated?.value || null);
      }}
      hideSearch
      popoverWidth={170}
    />
  );
};
